<app-menu-popup title='צרו קשר'>
    <ng-container class='content'>
        <p>אתר כל שירות מספק מידע כללי בלבד ואינו מעניק ייעוץ פרטני. אנו לא עונים לשאלות ופניות אישיות.</p>
        <ul>
            <li><span>אם יש לכם שאלות כלליות אז אנא שילחו דואל לכתובת</span>&nbsp;<a href='mailto:info@kolsherut.org.il'>info&#64;kolsherut.org.il</a></li>
            <li>אם יש לכם הערות/הארות/תיקונים לגבי מידע באתר, אנא לחצו על כפתור "מצאתי טעות בנתונים" המופיע בתחתית כל עמוד מידע </li>
        </ul>
    </ng-container>
</app-menu-popup>